<template>
  <div class="page-builder-layout category-page-layout">
    <main-head-component/>
    <page-builder-slot>
      <main-slide-other-pages
        :img_src="main_slide_component_data.img_src"
        :lazy_img_src="main_slide_component_data.lazy_img_src"
        :fill_slide="main_slide_component_data.fill_slide"
        :slide_height_min_height="main_slide_component_data.slide_height_min_height"
        :attach_form="main_slide_component_data.attach_form"
      />
      <div class="container text-center mt-40">
        <default-title
          :title="item.title"
          title_tag="h1"
        />
      </div>
<!--      <div class="container mt-30">-->
<!--        <job-categories-list-->
<!--          class="category-page-layout__categories"-->
<!--          :categories="children_categories"-->
<!--          :selected_category_alias="filters.article_category_alias"-->
<!--          @selectedCategory="selectedCategory"-->
<!--        />-->
<!--      </div>-->
      <div class="container mt-20 mt-xs-40" ref="articles">
        <div class="row">
          <template v-if="articles_loading">
            <preview-article
              v-for="(article, index) in article_item_list_skeleton"
              class="col-md-3 col-sm-6 col-12"
              :img_src="article.img_url"
              :title="article.title"
              :text="article.prev_text"
              :date="article.created_at"
              :href_to="article.link"
              loading
              :key="`preview-article_${uid}-${index}`"
            />
          </template>
          <template v-else-if="articles.length">
            <preview-article
              v-for="(article, index) in articles"
              v-show="show_all || index < article_per_view"
              class="col-md-3 col-sm-6 col-12"
              :img_src="article.img_url"
              :title="article.title"
              :text="article.prev_text"
              :date="article.created_at"
              :href_to="article.link"
              lazy_attr
              :key="`preview-article_${uid}-${index}`"
            />
          </template>
          <template v-else>
            <default-title
              title_tag="div"
              smaller
              class="col-12 text-center"
              :title="$t('text.no_articles_text')"/>
          </template>
        </div>
        <div
          v-if="pagination.total > article_per_view"
          class="mt-30 mb-120 d-flex justify-content-center">
<!--          <default-button-->
<!--            v-if="!show_all"-->
<!--            bordered-->
<!--            is_light-->
<!--            @click="show_all = true">-->
<!--            {{ $t('btn.explore') }}-->
<!--          </default-button>-->
          <pagination-list
            v-show="pagination.total"
            @pageChange="changePage"
            :pagination="pagination.list"
            :last_page="pagination.last_page"
            :active_page="pagination.page"/>
        </div>
      </div>
      <component
        v-for="(item, index) in components_data_to_show"
        :is="item.component_name_kebab"
        v-bind="item.component_data"
        :key="`builder-component_${index}`"/>
    </page-builder-slot>
    <footer-component/>
  </div>
</template>

<script>

import FooterComponent from "../parts/FooterComponent.vue";
import MainSlideOtherPages from "../builder_components/MainSlideOtherPages.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import JobCategoriesList from "../parts/job-components/JobCategoriesList.vue";
import PreviewArticle from "../parts/builder/PreviewArticle.vue";
import show_more_pagination_mixin from "../../mixins/show_more_pagination_mixin";
import JobListItem from "../parts/job-components/JobListItem.vue";
import {ARTICLE_ITEM_LIST} from "../../mixins/skeletton_objects";
import ShareButton from "../small_parts/ShareButton.vue";
import PaginationList from "../modules/Pagination/PaginationList.vue";
import DefaultButton from "../slots/DefaultButton.vue";
import {ssr_window} from "../../helpers/ssr";
import {getQueryObj} from "../../helpers/query_helper";
import {axiosArticles} from "../../helpers/axios_requests";
import axios from "axios";
import PageBuilderSlot from "../slots/PageBuilderSlot.vue";
import MainHeadComponent from "../builder_components/MainHeadComponent.vue";

const CancelToken = axios.CancelToken;
const MAIN_SLIDE_COMPONENT_NAME = 'main-slide-other-pages';
let axiosSource;
/**
 * Articles category layout (blog)
 */
export default {
  name: "CategoryPageLayout",
  mixins: [show_more_pagination_mixin],
  components: {
    MainHeadComponent,
    PageBuilderSlot,
    DefaultButton,
    PaginationList,
    ShareButton,
    JobListItem,
    PreviewArticle,
    JobCategoriesList,
    DefaultTitle,
    MainSlideOtherPages,
    FooterComponent,
  },
  computed: {
    item() {
      return this.$context?.item || {}
    },
    uid() {
      return this._uid
    },
    components_data() {
      return this.item.components || []
    },
    children_categories() {
      return this.$context?.children_categories || []
    },
    components_data_to_show() {
      return this.components_data.filter(el => el.component_name_kebab !== MAIN_SLIDE_COMPONENT_NAME)
    },
    main_slide_component() {
      return this.components_data.find(el => el.component_name_kebab === MAIN_SLIDE_COMPONENT_NAME) || null
    },
    main_slide_component_data() {
      let component_data = this.main_slide_component?.component_data || {}
      return {
        img_src: component_data?.img_src || '/images/page_data/blog_image-thumb.jpg',
        lazy_img_src: component_data?.lazy_img_src || '/images/page_data/blog_image.jpg',
        fill_slide: component_data?.fill_slide || '',
        attach_form: component_data?.attach_form || false,
        slide_height_min_height: component_data?.slide_height_min_height || '',
      }
    },
    article_item_list_skeleton() {
      return ARTICLE_ITEM_LIST(this.article_per_view)
    },
    article_per_view() {
      return 8
    },
  },
  data() {
    return {
      articles: [],
      articles_loading: false,
      filters: {
        article_category_alias: '',
      },
    }
  },
  beforeMount() {
    if (this.$context?.articles) {
      this.setArticles(this.$context.articles.collection || [])
      this.$set(this.pagination, 'list', this.$context.articles.pagination || [])
      this.pagination.last_page = this.$context.articles.last_page ?? 1
      this.pagination.total = this.$context.articles.total ?? 0
      console.log(this.pagination);
    }
    this.fillFilters(getQueryObj(ssr_window.location?.search))
    this.initFilterWatch()
    ssr_window.addEventListener('popstate', this.pageBackEvent);
  },
  methods: {
    setArticles(list) {
      if (!Array.isArray(list)) return
      this.$set(this, 'articles', list)
    },
    selectedCategory({alias}) {
      if (!alias) return
      this.filters.article_category_alias = this.filters.article_category_alias === alias ? '' : alias
    },
    changePage({page}) {
      this.pagination.page = page
      this.fetchArticles()
        .then(() => {
          this.$refs.articles.scrollIntoView({ behavior: "smooth" })
        })
    },
    fillFilters({article_category_alias, page}) {
      this.filters.article_category_alias = article_category_alias || ''
      this.pagination.page = Number(page || 1)
    },
    pageBackEvent(e) {
      // prevent popstate on hash change
      if (e.state === null) {
        return
      }
      this.destroyFilterWatch()

      this.fillFilters(getQueryObj(location.search))
      this.fetchArticles(false)

      this.initFilterWatch()
    },
    initFilterWatch() {
      this.filter_watch = this.$watch('filters', {
        deep: true,
        handler() {
          this.pagination.page = 1
          this.fetchArticles()
          // this.typing(this.fetchArticles)
        },
      })
    },
    async fetchArticles(push_state = true) {
      this.articles_loading = true
      if (axiosSource) {
        axiosSource.cancel('Operation canceled by the user');
      }
      axiosSource = CancelToken.source()
      await axiosArticles.fetchArticles(this.axios_filters, axiosSource.token)
        .then(({data}) => {
          if (push_state) {
            this.pushNewState()
          }
          this.setArticles(data.collection || [])
          this.pagination.list = this.mixGetPagination(data.pagination || [])
          this.pagination.last_page = data.last_page || 1
          this.pagination.total = data.total || 0
        })
        .finally(() => {
          setTimeout(() => {
            this.articles_loading = false
          }, 500)
        })
    },
  }
}
</script>
